<template>
    <div>
        <h1>Geen aanvraagcode opgegeven</h1>
        <p>
            Om een aanvraag te vervolledigen dient u de link uit de bevestigingsmail te volgen.
        </p>
    </div>
</template>

<script>
export default {
    name: 'home',
};
</script>
